module.exports = __webpack_public_path__ + "img/22.6ad25e4d.jpg";